export const formatRupiah = (number) => {
  // Jika angka null atau undefined, kembalikan Rp 0
  if (number === null || typeof number === 'undefined') {
    number = 0;
  }
  
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0, // Menghilangkan ,00
    maximumFractionDigits: 0, // Memastikan tidak ada desimal
  }).format(number);
};